require("./bootstrap");

const apps = [
  "AboutSteps",
  "AnchorsApp",
  "Animated",
  "CitiesSelector",
  "FAQ",
  "FAQTwo",
  "HowItsWork",
  "FamilyExperience",
  "NavApp",
  "NewsletterApp",
  "OthersCities",
  "PostcodeMap",
  "StudiosList",
  "StudiosMap",
  "BookSteps",
  "StudiosMapSelector",
  // 'StripeForm',
  "VueCarousel",
];

apps.forEach((app) => {
  require("./Apps/" + app + "/app.js");
});
